






import { Component, Prop, Vue } from "vue-property-decorator";
import MissingBanners from "./MissingBanners.vue";

@Component({
  components: {
    MissingBanners,
  },
})
export default class MissingBannersReport extends Vue {}
